import { gql } from '@apollo/client';

export const SET_AVAIL_OFFICER = gql`
mutation setAvailOfficer($input: SetAvailOfficerInput!) {
  setAvailOfficer(input: $input) {
    errors
    deptAttribute {
      id
      carNumber
      lastContactedAt
      notes
      radioNumber
      secondaryAddress
      status
      ori {
        id
        oriName
        abbreviation
      }
    }
    
  }
}
`

// Example input
// {
//   "input": {
//    "officerId": "3472",
//     "secondaryLocation": "Set from GraphiQL",
//     "notes": "Also set from GraphiQL",
//     "carNumber": "1",
//     "radioNumber": "11"
   
//   }
// }